import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import Modal from '@/components/UI/Modal';
import { mapState } from 'vuex';
export default {
  name: 'BumpAnimate',
  components: {
    Modal: Modal
  },
  settingKey: '碰蛋动画',
  setting: {
    动效播放延时: 300,
    动效时长: 1500
  },
  props: {
    awardInfo: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      isBump: false
    };
  },
  created: function () {
    var _created = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  computed: _objectSpread(_objectSpread({}, mapState('bump', ['myEggInfo', 'myShareCode', 'masterUserInfo', 'masterEggInfo'])), {}, {
    leftEgg: function leftEgg() {
      return this.masterEggInfo.egg_skin_url;
    },
    rightEgg: function rightEgg() {
      return this.myEggInfo.egg_skin_url;
    }
  }),
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.isBump = true;

      _this.$nextTick(function () {
        window.bodymovin.loadAnimation({
          path: '//vm.gtimg.cn/tencentvideo/vstyle/newvip/style/h5/animate/act_2019cny/pengLottieDefault/data.json',
          loop: false,
          autoplay: true,
          renderer: 'svg',
          // 渲染方式，有"html"、"canvas"和"svg"三种
          container: document.getElementById('lottie-animate')
        });
        setTimeout(function () {
          _this.$emit('animateSuccess');
        }, _this.setting.动效时长);
      });
    }, this.setting.动效播放延时);
  }
};